var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "fragment",
    [
      _c("p", [
        _vm._v(
          _vm._s(_vm.$t("request-package.requestApplicationDetails.subtitle"))
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    " +
            _vm._s(
              _vm.$t(
                "request-package.requestApplicationDetails.informationWillBeKeptPrivate"
              )
            ) +
            "\n  "
        ),
      ]),
      _vm._v(" "),
      _c("i18n", {
        attrs: {
          tag: "p",
          path: "request-package.requestApplicationDetails.customizeEmailFrequencyMsg",
        },
        scopedSlots: _vm._u([
          {
            key: "days",
            fn: function () {
              return [
                _c("a", { staticClass: "text-primary bold" }, [
                  _vm._v(_vm._s(_vm.emailFrequency)),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "route",
            fn: function () {
              return [
                _c(
                  "router-link",
                  {
                    staticClass: "text-primary clickable",
                    attrs: {
                      to: {
                        path: "/personal-settings/account/recurring-reminders",
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.$t(
                            "request-package.requestApplicationDetails.customizeEmailFrequencyBtn"
                          )
                        ) +
                        ".\n        "
                    ),
                    _c("icon", { attrs: { name: "external-link" } }),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c("b-col", { attrs: { cols: "5", lg: "4" } }, [
            _c("p", { staticClass: "bold my-3" }, [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.$t(
                      "request-package.requestApplicationDetails.sendRequestToIndividualCoapps"
                    )
                  ) +
                  "\n      "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { cols: "5", lg: "4" } },
            [
              _c(
                "material-input",
                [
                  _c("applicant-select", {
                    staticClass: "request-application-step",
                    attrs: {
                      id: "applicant-select",
                      value: _vm.selectedCoApplicants,
                      "applicants-to-exclude": [{ applicantIndex: 0 }],
                    },
                    on: { change: _vm.handleChangeCoApplicants },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("request-application-details-table", {
        attrs: {
          data: [_vm.mainApplicant].concat(_vm.selectedCoApplicants),
          "selected-property": _vm.applicationDetails.selectedProperty,
          "selected-mortgage-details":
            _vm.applicationDetails.selectedMortgageDetails,
        },
        on: { change: _vm.handleChangeApplicationDetails },
        scopedSlots: _vm._u([
          {
            key: "applicantFullName",
            fn: function (ref) {
              var row = ref.row
              return [
                row.applicantIndex === 0
                  ? _c("p", { staticClass: "mb-0" }, [
                      _vm._v(
                        "\n        " +
                          _vm._s(row.applicantFullName) +
                          "\n      "
                      ),
                    ])
                  : _c(
                      "li",
                      {
                        staticClass: "applicant-selection__choice",
                        attrs: {
                          title: _vm.$options.filters.getApplicantName(
                            row.applicantIndex,
                            row
                          ),
                        },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass:
                              "applicant-selection__choice__remove clickable",
                            attrs: { role: "presentation" },
                            on: {
                              click: function ($event) {
                                return _vm.handleRemoveApplicant(row)
                              },
                            },
                          },
                          [_vm._v("×")]
                        ),
                        _vm._v(
                          "\n        " +
                            _vm._s(
                              _vm.$options.filters.getApplicantName(
                                row.applicantIndex,
                                row
                              )
                            ) +
                            "\n      "
                        ),
                      ]
                    ),
              ]
            },
          },
        ]),
      }),
      _vm._v(" "),
      !_vm.isMainApplicantValid
        ? _c(
            "div",
            { staticClass: "text-danger" },
            [
              _c("icon", { attrs: { name: "exclamation-circle" } }),
              _vm._v(" "),
              _c("span", { staticClass: "mx-2" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.$t(
                        "request-package.requestApplicationDetails.mainApplicantValidationText"
                      )
                    ) +
                    "\n    "
                ),
              ]),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }